import { FC, useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router';

import useFeatureFlagsSwitcher from 'common/hooks/useFeatureFlagsSwitcher';
import { NewCoverage } from 'features/Insurance/pages/NewCoverage';
import { APP_LAYOUT_SCREEN_CLASSNAME } from 'layouts/AppLayout/constants';

import { InsuranceCoverageProvider } from './hooks/useInsuranceCoverage';
import { NewInsuranceCoverageProvider } from './hooks/useNewInsuranceCoverage';
import AccidentCoverageOffer from './pages/AccidentCoverageOffer';
import ComputerBreakageOffer from './pages/ComputerBreakageOffer';
import Coverage from './pages/Coverage';
import DebtRecoveryOffer from './pages/DebtRecoveryOffer';
import LegalAssistanceOffer from './pages/LegalAssistanceOffer';
import DebtRecovery from './pages/LegalSupport/DebtRecovery';
import LegalAssistance from './pages/LegalSupport/LegalAssistance';
import ComputerBreakage from './pages/MaterialAndBody/ComputerBreakage';
import Hospitalization from './pages/MaterialAndBody/Hospitalization';
import MobileScreen from './pages/MaterialAndBody/MobileScreen';
import PurchaseProtection from './pages/MaterialAndBody/PurchaseProtection';
import MobileScreenOffer from './pages/MobileScreenOffer';
import PaymentFraud from './pages/Payment/Fraud';
import Phishing from './pages/Payment/Phishing';
import HealthCostsAbroad from './pages/Transport/HealthCostsAbroad';
import RentalVehicle from './pages/Transport/RentalVehicle';
import TransportDelay from './pages/Transport/TransportDelay';
import WarrantyExtensionOffer from './pages/WarrantyExtensionOffer';
import * as routes from './routes';

const Insurance: FC = () => {
  const { pathname } = useLocation();
  const { featureFlags } = useFeatureFlagsSwitcher();

  useEffect(() => {
    // scroll to the top of the page
    const scrollableContainer = document.getElementsByClassName(
      APP_LAYOUT_SCREEN_CLASSNAME,
    );

    if (scrollableContainer) {
      // @ts-expect-error Object is possibly 'undefined'.
      scrollableContainer[0].scrollTo(0, 0);
    }
  }, [pathname]);

  const CoverageProvider = featureFlags.enableNewInsurance
    ? NewInsuranceCoverageProvider
    : InsuranceCoverageProvider;

  return (
    <CoverageProvider>
      <Switch>
        <Route
          component={featureFlags.enableNewInsurance ? NewCoverage : Coverage}
          exact
          path={routes.coverage}
        />

        {featureFlags.enableNewInsurance ? (
          <Route
            component={Hospitalization}
            path={routes.hospitalization.pathname}
          />
        ) : null}

        {featureFlags.enableNewInsurance ? (
          <Route component={Phishing} path={routes.phishing.pathname} />
        ) : null}

        {featureFlags.enableNewInsurance ? (
          <Route component={PaymentFraud} path={routes.paymentFraud.pathname} />
        ) : null}

        {featureFlags.enableNewInsurance ? (
          <Route
            component={PurchaseProtection}
            path={routes.purchaseProtection.pathname}
          />
        ) : null}

        {featureFlags.enableNewInsurance ? (
          <Route
            component={TransportDelay}
            path={routes.transportDelay.pathname}
          />
        ) : null}

        {featureFlags.enableNewInsurance ? (
          <Route
            component={RentalVehicle}
            path={routes.rentalVehicle.pathname}
          />
        ) : null}

        {featureFlags.enableNewInsurance ? (
          <Route
            component={HealthCostsAbroad}
            path={routes.healthCostsAbroad.pathname}
          />
        ) : null}

        {!featureFlags.enableNewInsurance ? (
          <Route
            component={AccidentCoverageOffer}
            path={routes.accidentCoverage.pathname}
          />
        ) : null}

        <Route
          component={
            featureFlags.enableNewInsurance
              ? ComputerBreakage
              : ComputerBreakageOffer
          }
          path={routes.computerBreakage.pathname}
        />

        <Route
          component={
            featureFlags.enableNewInsurance ? DebtRecovery : DebtRecoveryOffer
          }
          path={routes.debtRecovery.pathname}
        />

        <Route
          component={
            featureFlags.enableNewInsurance
              ? LegalAssistance
              : LegalAssistanceOffer
          }
          path={routes.legalAssistance.pathname}
        />

        <Route
          component={
            featureFlags.enableNewInsurance ? MobileScreen : MobileScreenOffer
          }
          path={routes.mobileScreen.pathname}
        />

        {!featureFlags.enableNewInsurance ? (
          <Route
            component={WarrantyExtensionOffer}
            path={routes.warrantyExtension.pathname}
          />
        ) : null}

        <Route path="*">
          <Redirect to={routes.coverage} />
        </Route>
      </Switch>
    </CoverageProvider>
  );
};

export default Insurance;
